import axiosInstance from '../../api/axiosInstance';
import { PermissionsResponse } from '../../types/permissions';

export const permissionService = {
  // Obtener todos los permisos
  getPermissions: async (): Promise<PermissionsResponse> => {
    const response = await axiosInstance.get<PermissionsResponse>('/users/permissions');
    return response.data;
  }
};
